<template>
    <div>
        <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
            <template v-slot:item="props">
                <tr>
                    <td v-for="(header, index) in headers"
                        :key="index"
                        :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)">
                        <span>{{ props.item[header.value] }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        props: {
            items: {
                default: () => [],
                type: Array
            },
            properties: {
                default: () => [],
                type: Array
            }
        },
        data: () => ({
            headers: [
                {
                    text: "EmpCode",
                    value: "empCode",
                    sortable: false
                },
                {
                    text: "Address",
                    value: "address",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "School Country",
                    value: "country",
                    sortable: false
                },
                {
                    text: "YearFr",
                    value: "yearFr",
                    sortable: false
                },
                {
                    text: "YearTo",
                    value: "yearTo",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Start Date",
                    value: "sdate",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "End Date",
                    value: "edate",
                    sortable: false
                },
                {
                    text: "School Code",
                    value: "schoolCode",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Educational Establishment",
                    value: "eduEstCode",
                    sortable: false
                },
                {
                    text: "Course Code",
                    value: "courseCode",
                    sortable: false
                },
                {
                    text: "EduAttCode",
                    value: "eduAttCode",
                    sortable: false
                },
                {
                    text: "MajorCode",
                    value: "majorCode",
                    sortable: false
                },
                {
                    text: "Honor",
                    value: "honor",
                    sortable: false
                },
                {
                    text: "Level",
                    value: "level",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Final Grade",
                    value: "finalGrade",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "License Number",
                    value: "licenseNumber",
                    sortable: false
                },
                {
                    text: "Remarks",
                    value: "remarks",
                    sortable: false
                }
            ]
        }),
        computed: {},
        methods: {
            propRequired(prop, index) {
                var result = this.properties.filter(item => {
                    return (
                        item.property.toLowerCase() == prop.toLowerCase() &&
                        item.index == index
                    );
                });

                if (result.length > 0) return "red lighten-1";
                else return "";
            },
            all(index) {
                var result = this.properties.filter(item => {
                    return (
                        item.property == "ALL" &&
                        item.mode == "EDUCBACK" &&
                        item.index == index
                    );
                });
                if (result.length > 0) return true;
                else false;
            }
        }
    };
</script>